import { Text } from '../index';
import { Link } from 'react-router';
import * as React from 'react';
type Props = {
  to: string;
};
const BackLink: React.FC<React.PropsWithChildren<Props>> = ({
  to,
  children,
}) => {
  return (
    <Link to={to}>
      <Text
        heading='sm'
        weight='semi-bold'
        color='secondary-gray'
        className='text-uppercase'
        style={{ letterSpacing: '0.0975rem' }}
      >
        {children}
      </Text>
    </Link>
  );
};

export default BackLink;
